import { Card, CardBody, Col, Container } from 'reactstrap'
import { Carts, Ecommerce } from '../../../../utils/Constant'
import CartData from './CartData'
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs/Breadcrumbs'
import CardHeaderCommon from '../../../../CommonElements/CommonCardHeader/CardHeaderCommon'

const CartContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Carts} parent={Ecommerce} />
      <Container fluid>
        <Col sm="12">
          <Card>
            <CardHeaderCommon title={Carts} />
            <CardBody>
              <CartData />
            </CardBody>
          </Card>
        </Col>
      </Container>
    </>
  )
}

export default CartContainer